import { render, staticRenderFns } from "./ISARoomBedExitSettingsModal.vue?vue&type=template&id=33624206&scoped=true&"
import script from "./ISARoomBedExitSettingsModal.vue?vue&type=script&lang=js&"
export * from "./ISARoomBedExitSettingsModal.vue?vue&type=script&lang=js&"
import style0 from "./ISARoomBedExitSettingsModal.vue?vue&type=style&index=0&id=33624206&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33624206",
  null
  
)

export default component.exports